import type { CustomerSort, CustomerSortBy } from '../../../server/types/list-view-types.ts';
import { SortOrder } from '../../../server/types/list-view-types.ts';
import { useAnalytics } from '../../analytics/hooks/use-analytics.ts';
import { useGenericListViewSorting } from '../../list-views/hooks/use-generic-list-view-sorting.tsx';
import { useCustomerListFilters } from './use-customer-list-filters.tsx';

export function useCustomerListSorting() {
    const {
        appliedFilters: { sortingFilter },
        setAppliedFilters,
    } = useCustomerListFilters();
    const sendEvent = useAnalytics();

    return useGenericListViewSorting<CustomerSortBy>(
        sortingFilter,
        (sortingFilter: CustomerSort | undefined) => {
            // This callback only runs on user sort actions (never on initial

            setAppliedFilters((filters) => ({
                ...filters,
                sortingFilter: sortingFilter ?? undefined,
            }));
            if (sortingFilter) {
                sendEvent('customer_list_sort_used', {
                    column: sortingFilter.field,
                    direction: sortingFilter.direction === SortOrder.DESC ? 'DESC' : 'ASC',
                });
            }
        },
    );
}
